import * as React from "react";

import { debounce, noop } from "lodash";

import JumpTo from "~/search/JumpTo";
import SearchForm from "~/search/SearchForm";

import styles from "./SearchPanel.module.css";

const { useState, useMemo, useCallback, useEffect } = React;

export default function SearchPanel() {
	// the state of text input
	const [input, setInput] = useState("");
	const onInputChange = useCallback(
		(value: string) => {
			setInput(value);
		},
		[setInput],
	);
	// the state of the network request - separate from input so we can debounce changes
	const [query, _setQuery] = useState("");
	const setQuery = useMemo(() => debounce(_setQuery, 500), [_setQuery]);
	useEffect(() => setQuery(input), [setQuery, input]);

	const setQueryNow = useCallback(
		(v: string) => {
			setInput(v);
			setQuery(v);
			return setQuery.flush();
		},
		[setInput, setQuery],
	);
	const onClear = useCallback(() => setQueryNow(""), [setQueryNow]);
	return (
		<section className={styles.panel}>
			<header className={styles.header}>
				<SearchForm
					value={input}
					onChange={onInputChange}
					placeholder="Jump to…"
					onClear={onClear}
					onSearch={setQuery.flush}
				/>
			</header>
			<div className={styles.inner}>
				<JumpTo query={query} onClose={noop} />
			</div>
		</section>
	);
}
